import request from '@/config/axios';

/**
 * PersonalPostAppList
 * 获取我的应用列表
 * @return
 */
export function PersonalPostAppList(data) {
  return request({
    url: '/company/getAppInfoByStatus',
    method: 'POST',
    data
  });
}


/**
 * PersonalPostMessageList
 * 获取通知列表
 * @return
 */
export function PersonalPostMessageList(data) {
  return request({
    url: '/company/listMessage',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostMessageList
 * 删除指定通知
 * @return
 */
export function PersonalGetDeleteMessage(data) {
  return request({
    url: '/company/deleteMessage',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalGetAppOnlineCheck
 * 上线申请检查
 * @return
 */
export function PersonalGetAppOnlineCheck(data) {
  return request({
    url: '/company/onlineApplyCheck',
    method: 'GET',
    params: data
  });
}

/*----应用管理部分----*/

/**
 * PersonalPostAppInfoById
 * 获取应用详情
 * @return
 */
export function PersonalPostAppInfoById(data) {
  return request({
    url: '/company/appInfo/getAppInfoById',
    method: 'POST',
    data
  });
}

/**
 * PersonalGetDevelopConfigInfo
 * 获取应用配置信息
 * @return
 */
export function PersonalGetDevelopConfigInfo(data) {
  return request({
    url: '/company/getDevelopInfoByAppId',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalPostUpdateDevelopConfig
 * 更新应用配置信息
 * @return
 */
export function PersonalPostUpdateDevelopConfig(data) {
  return request({
    url: '/company/updateDevelopInfo',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostApiInfoList
 * 获取接口订阅列表
 * @return
 */
export function PersonalPostApiInfoList(data) {
  return request({
    url: '/company/listApiApplyInfo',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostDeleteApiApply
 * 取消指定应用订阅
 * @return
 */
export function PersonalPostDeleteApiApply(data) {
  return request({
    url: '/company/deletApiApplyByCondition',
    method: 'POST',
    data
  });
}

/**
 * PersonalGetApiGroupList
 * 获取订阅应用查询分组
 * @return
 */
export function PersonalGetApiGroupList(data) {
  return request({
    url: '/company/apiInfo/listApiGroupInfo',
    method: 'GET',
    params: data
  });
}


/**
 * PersonalPostOpenInfoList
 * 获取开通查询模块列表
 * @return
 */
export function PersonalPostOpenInfoList(data) {
  return request({
    url: '/company/listAppOpendInfoByCondition',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostDicAreaList
 * 获取省数据
 * @return
 */
export function PersonalPostDicAreaList(data) {
  return request({
    url: '/company/getDicAreaList',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostEudSchoolList
 * 获取机构数据
 * @return
 */
export function PersonalPostEudSchoolList(data) {
  return request({
    url: '/company/getEduSchoolList',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostApiUnApplyInfo
 * 获取接口订阅个类型接口数值
 * @return
 */
export function PersonalPostApiUnApplyInfo(data) {
  return request({
    url: '/company/listApiUnApplyInfo',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostSubmitApi
 * 提交订阅接口
 * @return
 */
export function PersonalPostSubmitApi(data) {
  return request({
    url: '/company/apiApply',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostOnlineAppApply
 * 提交应用上线申请
 * @return
 */
export function PersonalPostOnlineAppApply(data) {
  return request({
    url: '/company/onLineAppApply',
    method: 'POST',
    data
  });
}

/*----组件管理start----*/

/**
 * PersonalGetModuleInfoListByAppId
 * 获取应用组件信息
 * @return
 */
export function PersonalGetModuleInfoListByAppId(data) {
  return request({
    url: '/company/moduleManage/getModuleInfoListByAppId',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalGetAppBaseInfoByAppId
 * 获取应用基本信息
 * @return
 */
export function PersonalGetAppBaseInfoByAppId(data) {
  return request({
    url: '/company/moduleManage/getAppBaseInfoByAppId',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalGetModuleBaseInfoByModuleId
 * 编辑时查看详情
 * @return
 */
export function PersonalGetModuleBaseInfoByModuleId(data) {
  return request({
    url: '/company/moduleManage/getModuleBaseInfoByModuleId',
    method: 'GET',
    params: data
  });
}
/**
 * PersonalPostUpdateModuleInfo
 * 新增或修改组件
 * @return
 */
export function PersonalPostUpdateModuleInfo(data) {
  return request({
    url: '/company/moduleManage/updateModuleInfo',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostUpdateModuleInfo
 * 查看组件配置信息
 * @return
 */
export function PersonalGetModuleConfigById(data) {
  return request({
    url: '/company/moduleManage/getModuleConfigById',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalPostUpdateModuleApiInfo
 * 更新调试组件中调用接口信息
 * @return
 */
export function PersonalPostUpdateModuleApiInfo(data) {
  return request({
    url: '/company/moduleManage/updateModuleApiInfo',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostUpdateModuleUserInfo
 * 更新调试组件中绑定的用户信息
 * @return
 */
export function PersonalPostUpdateModuleUserInfo(data) {
  return request({
    url: '/company/moduleManage/updateModuleUserInfo',
    method: 'POST',
    data
  });
}

/**
 * PersonalGetModuleManageLoginOut
 * 绑定的用户退出登录
 * */
export function PersonalGetModuleManageLoginOut(data) {
  return request({
    url: '/company/moduleManage/loginOut',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalPostModuleManageModuleInfo
 * 调用应用开发方提供接口拿到组件数据
 * @return
 */
export function PersonalPostModuleManageModuleInfo(data) {
  return request({
    url: '/company/moduleManage/getModuleInfo',
    method: 'POST',
    data
  });
}

/**
 * PersonalPostUpdateModuleConfig
 * 组件配置信息保存
 * @return
 */
export function PersonalPostUpdateModuleConfig(data) {
  return request({
    url: '/company/moduleManage/updateModuleConfig',
    method: 'POST',
    data
  });
}

/**
 * PersonalGetModuleManageOnLine
 * 组件上线
 * @return
 */
export function PersonalGetModuleManageOnLine(data) {
  return request({
    url: '/company/moduleManage/onLine',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalGetModuleManageOffLine
 * 组件下线
 * @return
 */
export function PersonalGetModuleManageOffLine(data) {
  return request({
    url: '/company/moduleManage/offLine',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalGetModuleInfoById
 * 组件查看详情
 * @return
 */
export function PersonalGetModuleInfoById(data) {
  return request({
    url: '/company/moduleManage/getModuleInfoById',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalDataGetDateLevel
 * 获取级别列表
 * @return
 */
 export function PersonalDataGetDateLevel() {
  return request({
    url: '/company/getDateLevel',
    method: 'GET'
  });
}


/**
 * PersonalDataGetDateSceneByAppId
 * 根据应用类型获取场景列表
 * @return
 */
 export function PersonalDataGetDateSceneByAppId(data) {
  return request({
    url: '/company/getDateSceneByAppId',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalDataGetTree
 * 根据应用类型获取标准数据树
 * @return
 */
 export function PersonalDataGetTree(data) {
  return request({
    url: '/company/tree',
    method: 'GET',
    params: data
  });
}

/**
 * PersonalDataPageListDateStandardInfo
 * 根据条件获取标准信息列表
 * @return
 */
 export function PersonalDataPageListDateStandardInfo(data) {
  return request({
    url: '/company/pageListDateStandardInfo',
    method: 'POST',
    data
  });
}


/**
 * PersonalDataGetDataPropertyByCode
 * 根据标准code查询标准属性
 * @return
 */
 export function PersonalDataGetDataPropertyByCode(data) {
  return request({
    url: '/company/getDataPropertyByCode',
    method: 'GET',
    params: data
  });
}


/**
 * PersonalDataPageListDataByCondition
 * 根据条件获取标准数据上报信息列表
 * @return
 */
 export function PersonalDataPageListDataByCondition(data) {
  return request({
    url: '/company/pageListDataByCondition',
    method: 'POST',
    data
  });
}


/**
 * PersonalDataDeleteDataStandard
 * 取消上报
 * @return
 */
 export function PersonalDataDeleteDataStandard(data) {
  return request({
    url: '/company/deleteDataStandard',
    method: 'POST',
    data
  });
}


/**
 * PersonalDataApplyDataStandard
 * 上报申请
 * @return
 */
 export function PersonalDataApplyDataStandard(data) {
  return request({
    url: '/company/applyDataStandard',
    method: 'POST',
    data
  });
}

/**
 * selectAppApplyIndexList
 * 已申请评分指标查询接口
 * @return
 */
 export function selectAppApplyIndexList(data) {
  return request({
    url: '/scoring/selectAppApplyIndexList',
    method: 'POST',
    data
  });
}

/**
 * selectAppNoApplyIndexList
 * 未申请评分指标查询接口
 * @return
 */
 export function selectAppNoApplyIndexList(data) {
  return request({
    url: '/scoring/selectAppNoApplyIndexList',
    method: 'POST',
    data
  });
}

/**
 * submitApplyIndex
 * 评分标准申请提交接口
 * @return
 */
 export function submitApplyIndex(data) {
  return request({
    url: '/scoring/submitApplyIndex',
    method: 'POST',
    data
  });
}

/**
 * cancelApplyIndex
 * 评分标准申请取消接口
 * @return
 */
 export function cancelApplyIndex(data) {
  return request({
    url: '/scoring/cancelApplyIndex',
    method: 'GET',
    params:data
  });
}

/**
 * listOperateIntro
 * 应用评分操作说明列表查询接口
 * @return
 */
 export function listOperateIntro(data) {
  return request({
    url: '/scoring/listOperateIntro',
    method: 'POST',
    data
  });
}

/**
 * addOperateIntro
 * 应用评分操作说明新增接口
 * @return
 */
 export function addOperateIntro(data) {
  return request({
    url: '/scoring/addOperateIntro',
    method: 'POST',
    data
  });
}

/**
 * getOperateIntro
 * 应用评分操作说明详情查询接口
 * @return
 */
 export function getOperateIntro(id) {
  return request({
    url: '/scoring/getOperateIntro?id='+id,
    method: 'GET',
  });
}

/**
 * updateOperateIntro
 * 应用评分操作说明修改接口
 * @return
 */
 export function updateOperateIntro(data) {
  return request({
    url: '/scoring/updateOperateIntro',
    method: 'POST',
    data,
  });
}

/**
 * deleteOperateIntro
 * 应用评分操作说明删除接口
 * @return
 */
 export function deleteOperateIntro(id) {
  return request({
    url: '/scoring/deleteOperateIntro?id='+id,
    method: 'GET',
  });
}

/**
 * dictList
 * 指标分类
 * @return
 */
export function dictList(id) {
  return request({
    url: '/dict/list?dictTypeId='+id,
    method: 'GET',
  });
}

/**
 * submitApplyJudgeStandard
 * 评分标准申请提交判断数据标准接口
 * @return
 */
 export function submitApplyJudgeStandard(data) {
  return request({
    url: '/scoring/submitApplyJudgeStandard',
    method: 'GET',
    params:data,
  });
}
/*----组件管理end----*/

/**
 * 
 * 邮箱验证
 * @return
 */
export function sendVerificationCodeByEmail(data) {
  return request({
    url: '/company/sendVerificationCodeByEmail',
    method: 'POST',
    data
  });
}

export function getAppSecret(data) {
  return request({
    url: '/company/getAppSecret',
    method: 'POST',
    data
  });
}

/**
 * 数据授权列表
 */
export function getListApiScope(data) {
  return request({
    url: '/appinfo/listApiScopeByAppId',
    method: 'POST',
    data
  })
}

/**
 * 数据授权日志
 */
export function getListApiScopeLog(data) {
  return request({
    url: '/appinfo/listApiScopeLog',
    method: 'POST',
    data
  })
}

/**
 * 分页获取应用积分操作记录接口
 */
export function pageListAppIndexRecord(data) {
  return request({
    url: '/scoring/getIndexRecordList',
    method: 'POST',
    data
  })
}

/**
 * 分页获取应用解析失败操作日志接口
 */
export function pageListAppRecordLog(data) {
  return request({
    url: '/scoring/getIndexRecordLogList',
    method: 'POST',
    data
  })
}

/**
 * 评分指标列表查询接口
 */
export function getIndexList() {
  return request({
    url: '/scoring/listScoringIndex',
    method: 'GET',
  })
}

/**
 * 获取解析日志查询条件
 */
export function getRecordLogCondition() {
  return request({
    url: '/scoring/getRecordLogCondition',
    method: 'GET',
  })
}

/**
 * 获取标准名称列表
 */
export function getListStandardDefine(appId) {
  return request({
    url: '/company/listStandardDefineByAppId?appId=' + appId,
    method: 'GET',
  });
}

/**
 * 获取标准数据详情
 */
export function getStandardDataById(data) {
  return request({
    url: '/company/getStandardDataById',
    method: 'GET',
    params: data
  })
}
